import { ColumnDescription } from "react-bootstrap-table-next";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import Table from "../../../Components/Table";
import {
    EfetivarVisitarVendasController,
    ExportarGestaoDeVisitaVendasController,
    GestaoDeVisitaVendasController,
} from "../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import usePaginationFilter from "../../../hooks/usePaginationFilter";
import {
    IGestaoDeVisitasBody,
    IGestaoDeVisitasLst,
} from "../../../Interfaces/Vendas/GestaoDeVisitas/GestaoVisitasInterfaces";
import FiltroDeVisitas from "./FiltroDeVisitas";
import { formatedTelefone } from "../../../Tools/FormatTools";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import Swal from "sweetalert2";

const filtroInicial: IGestaoDeVisitasBody = {
    DT_INICIO: "",
    DT_FIM: "",
    DS_CLIENTE: "",
    ID_EQUIPE_VENDAS: [],
    ID_PONTO_VENDA: 0,
    DS_STATUS: "",
    ID_USUARIO_RESPONSAVEL: 0,
};

export default function GestaoDeVisitas() {
    const FILTRO_GESTAO_VISITAS = sessionStorage.getItem(
        "FILTRO_GESTAO_VISITAS"
    );

    const { PageFilter, setPage, setFilter } =
        usePaginationFilter<IGestaoDeVisitasBody>({
            page: 1,
            filter: FILTRO_GESTAO_VISITAS
                ? JSON.parse(FILTRO_GESTAO_VISITAS)
                : filtroInicial,
        });

    const handleFilter = (formData: IGestaoDeVisitasBody) => {
        const filterFormData = {
            ...formData,
        };
        PageFilter.page = 1;
        setFilter(filterFormData);
        sessionStorage.setItem(
            "FILTRO_GESTAO_VISITAS",
            JSON.stringify(filterFormData)
        );
    };

    const {
        value: gestaoDeVisitasLst,
        loading: gestaoDeVisitasLstLoading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return GestaoDeVisitaVendasController(PageFilter.page, {
            ...PageFilter.filter,
            DT_FIM: PageFilter.filter?.DT_FIM ?? "",
            DT_INICIO: PageFilter.filter?.DT_INICIO ?? "",
            DS_CLIENTE: PageFilter.filter?.DS_CLIENTE ?? "",
            ID_EQUIPE_VENDAS: PageFilter.filter?.ID_EQUIPE_VENDAS ?? [],
            ID_PONTO_VENDA: PageFilter.filter?.ID_PONTO_VENDA ?? 0,
            DS_STATUS: PageFilter.filter?.DS_STATUS ?? "",
            ID_USUARIO_RESPONSAVEL:
                PageFilter.filter?.ID_USUARIO_RESPONSAVEL ?? 0,
        });
    }, [PageFilter]);

    const totalPages = gestaoDeVisitasLst?.NR_PAGINAS;

    const {
        execute: EfetivarVisitarVendas,
        loading: EfetivarVisitarVendasLoading,
    } = useAsyncCallback(EfetivarVisitarVendasController);

    const gestaoVisitaColumns: Array<ColumnDescription<IGestaoDeVisitasLst>> = [
        {
            dataField: "DS_CLIENTE",
            text: "Cliente",
            formatter: (_, row) =>
                row.DS_CLIENTE ? (
                    <span>{row.DS_CLIENTE}</span>
                ) : (
                    <span>Não Possui Cliente</span>
                ),
        },
        {
            dataField: "DS_EMAIL",
            text: "Email",
        },
        {
            dataField: "NR_TELEFONE",
            text: "Telefone",
            formatter: (c) => (c ? formatedTelefone(c) : "-"),
        },
        {
            dataField: "DS_ORIGEM",
            text: "Origem",
        },
        {
            dataField: "DS_CORRETOR",
            text: "Corretor",
        },
        {
            dataField: "DS_EQUIPE",
            text: "Equipe",
            formatter: (_, row) =>
                row.DS_EQUIPE ? (
                    <span>{row.DS_EQUIPE}</span>
                ) : (
                    <span>Sem Equipe de Venda</span>
                ),
        },
        {
            dataField: "DS_PONTO_VENDA",
            text: "Ponto de Venda",
        },
        {
            dataField: "DS_TIPO_VISITA",
            text: "Tipo de Visita",
        },
        {
            dataField: "DT_DATA_VISITA",
            text: "Data",
            formatter: (c) => (c ? new Date(c).toLocaleDateString() : "-"),
        },
        {
            dataField: "FL_EFETIVADA",
            text: "Situação",
            formatter: (c) =>
                c ? "Visita Confirmada" : "Visita Não Confirmada",
        },
        {
            dataField: "FL_EFETIVADA",
            text: "",
            formatter: (_, row) =>
                !row.FL_EFETIVADA ? (
                    <button
                        className="btn btn-success btn-sm"
                        title="Confirmar Visita"
                        disabled={EfetivarVisitarVendasLoading}
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja confirmar a visita?",
                                showCancelButton: true,
                                confirmButtonText: "Sim",
                                cancelButtonText: "Não",
                                icon: "question",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    EfetivarVisitarVendas(
                                        row.ID_CASO_VISITA,
                                        true
                                    ).then(() => {
                                        updateList();
                                    });
                                }
                            });
                        }}
                    >
                        Confirmar Visita
                    </button>
                ) : (
                    <button
                        className="btn btn-danger btn-sm"
                        title="Não Confirmar Visita"
                        disabled={EfetivarVisitarVendasLoading}
                        onClick={() => {
                            Swal.fire({
                                title: "Deseja não confirmar a visita?",
                                showCancelButton: true,
                                confirmButtonText: "Sim",
                                cancelButtonText: "Não",
                                icon: "question",
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    EfetivarVisitarVendas(
                                        row.ID_CASO_VISITA,
                                        false
                                    ).then(() => {
                                        updateList();
                                    });
                                }
                            });
                        }}
                    >
                        Não Confirmar Visita
                    </button>
                ),
        },
    ];

    return (
        <div className="card card-custom p-10">
            <div className="w-100 d-flex justify-content-between align-items-center mb-8">
                <h4>Gestão de Visitas</h4>
            </div>

            <Table
                defaultStyle={{
                    align: "center",
                    classes: "p-8",
                }}
                bordered={false}
                striped
                columns={gestaoVisitaColumns}
                data={gestaoDeVisitasLst?.Visitas ?? []}
                keyField="ID_CASO_VISITA"
                classes="v-middle-cells"
                onTableChange={(type, newState) => {
                    setPage(newState.page);
                }}
                remote={{ pagination: true }}
                wrapperClasses="mw-100 custom-scroll"
                totalPages={totalPages}
                noDataIndication={
                    <div className="text-muted text-center">
                        Esse atendimento não possui nenhuma Visita vinculada
                    </div>
                }
                loading={
                    gestaoDeVisitasLstLoading || EfetivarVisitarVendasLoading
                }
                noSearch
            />

            <FiltroDeVisitas
                handleFilter={handleFilter}
                defaultFilter={PageFilter.filter}
            />
            <ExportExcel
                baixarExcelController={async () =>
                    ExportarGestaoDeVisitaVendasController({
                        ...PageFilter.filter,
                        DT_FIM: PageFilter.filter?.DT_FIM ?? "",
                        DT_INICIO: PageFilter.filter?.DT_INICIO ?? "",
                        DS_CLIENTE: PageFilter.filter?.DS_CLIENTE ?? "",
                        ID_EQUIPE_VENDAS:
                            PageFilter.filter?.ID_EQUIPE_VENDAS ?? [],
                        ID_PONTO_VENDA: PageFilter.filter?.ID_PONTO_VENDA ?? 0,
                        DS_STATUS: PageFilter.filter?.DS_STATUS ?? "",
                        ID_USUARIO_RESPONSAVEL:
                            PageFilter.filter?.ID_USUARIO_RESPONSAVEL ?? 0,
                    })
                }
                nomeArquivo={"Gestao_Visitas"}
            />
        </div>
    );
}
